export const PERMISSION_KEYS = [
    "use_system",
    "read_user",
    "write_user",
    "read_branch",
    "write_branch",
    "manage_branch",
    "read_menu",
    "write_menu",
    "read_courier",
    "write_courier",
    "read_review",
    "write_review",
    "read_order",
    "write_order",
    "read_promotion",
    "write_promotion"
] as const

export type PermissionKey = typeof PERMISSION_KEYS[number]
